import { langCache} from './langCache';

/**
 * Creates a language loader that lazily fetches and caches locale data.
 */
export function createLangLoader(getLocale, getDefault) {
    return async function loadLangs(langInfo) {
        if (!langCache.data) {
            langCache.data = {
                currentLang: null,
                defaultLang: null,
                isHE: langInfo.isHigherEducationEnabled,
                currentCultureName: langInfo.currentCultureName
            };
            langCache.data.currentLang = await getLocale(langInfo.currentCultureName);
            langCache.data.defaultLang = await getDefault();
            langCache.data.currentLang = langCache.data.currentLang ?? langCache.data.defaultLang;
        }
    };
}